import { apiPost, apiGet } from './client'

export async function loginAdmin(email: string, password: string) {
  return apiPost('/auth/login', undefined, { email, password })
}

export async function getMe(token: string) {
  return apiGet('/auth/me', token)
}
